import { Routes, Route } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useEffect } from "react";

import "./App.css";

import { VideoPageMontronix } from "./pages/cepr_montronix/VideoPage/organoids/VideoPage";
import { PhotoPageMontronix } from "./pages/cepr_montronix/PhotoPage/organoids/PhotoPage";
import { ModelPageMontronix } from "./pages/cepr_montronix/ModelPage/organoids/ModelPage";

import { VideoPagePWA } from "./pages/cepr_pwa/VideoPage/organoids/VideoPage";
import { PhotoPagePWA } from "./pages/cepr_pwa/PhotoPage/organoids/PhotoPage";
import { ModelPagePWA } from "./pages/cepr_pwa/ModelPage/organoids/ModelPage";

import { MainPagePwa } from "./pages/cepr_pwa/MainPage/organoids/MainPage";
import { MainPageMontronix } from "./pages/cepr_montronix/MainPage/organoids/MainPage";
import { MainPageGenral } from "./pages/MainPageGeneral/organoids/MainPage";
import { FullScreenButton } from "./common/UI/FullScreenButton/organoids/FullScreenButton";
import { $GuideMode, clearModelMonSlides, clearModelSlides, clearPhotoSlides, clearSlides_LeftSection, clearSlides_RightSection, clearVideoSlides, resetModelMonSlides, resetModelSlides, resetPhotoSlides, resetSlides_LeftSection, resetSlides_RightSection, resetVideoSlides, setOpenModel, setOpenModelMon, setOpenVideo } from "./common/UI/GuideButtons/logic/GuideLogic";
import { useStore } from "effector-react";

function App() {
  const GuideMode = useStore($GuideMode);
  const { i18n } = useTranslation();
  if ("serviceWorker" in navigator) {
    navigator.serviceWorker
    .register("/presentation/serviceworker.js")
      .then((reg) => console.log("service worker registered",reg))
      .catch((err) => console.log("service worker not registered", err));
  }
  useEffect(() => {
    if (localStorage.getItem("language") === undefined) {
      localStorage.setItem("language", "ru");
    } else {
      i18n.changeLanguage(localStorage.getItem("language")?.toString());
    }
  }, [i18n]);
  useEffect(()=>{
    if (GuideMode) {
      clearSlides_LeftSection()
      clearSlides_RightSection()
      clearPhotoSlides()
      clearVideoSlides()
      clearModelSlides()
      clearModelMonSlides()
      setOpenVideo(false)
      setOpenModel(false)
      setOpenModelMon(false)
  } else {
      resetSlides_LeftSection()
      resetSlides_RightSection()
      resetPhotoSlides()
      resetVideoSlides()
      resetModelSlides()
      resetModelMonSlides()
      setOpenVideo(true)
      setOpenModel(true)
      setOpenModelMon(true)
  }
  },[GuideMode])
  let params = new URL(window.location.href).searchParams;

  return (
    <div className="App">
      {params.get("url") && params.get("url")?.length !== 0 ? null : (
        <FullScreenButton />
      )}
      <Routes>
        <Route path={"/"} element={<MainPageGenral />} />
        <Route path={"/pwa"} element={<MainPagePwa />} />
        <Route path={"/montronix"} element={<MainPageMontronix />} />
        <Route path={"/pwa/photo"} element={<PhotoPagePWA />} />
        <Route path={"/pwa/video"} element={<VideoPagePWA />} />
        <Route path={"/pwa/model"} element={<ModelPagePWA />} />
        <Route path={"/montronix/photo"} element={<PhotoPageMontronix />} />
        <Route path={"/montronix/video"} element={<VideoPageMontronix />} />
        <Route path={"/montronix/model"} element={<ModelPageMontronix />} />
      </Routes>
    </div>
  );
}

export default App;
